import { render, staticRenderFns } from "./NewsDetailSidebar.vue?vue&type=template&id=e3101dec&scoped=true&"
import script from "./NewsDetailSidebar.vue?vue&type=script&lang=js&"
export * from "./NewsDetailSidebar.vue?vue&type=script&lang=js&"
import style0 from "./NewsDetailSidebar.vue?vue&type=style&index=0&id=e3101dec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3101dec",
  null
  
)

export default component.exports